import { Box } from '@mui/material';
import * as React from 'react';
import { useMemo } from 'react';

import { useLoggedInUserRoles } from '~/components/Auth';
import { PortalErrorBoundary } from '~/components/PortalErrorBoundary';
import { useModulesConfig } from '~/data/company';
import { AdminWorkspaceRoles } from '~/data/user/role';
import { MyWorkspaceWidgetNames } from '~/scenes/MyWorkspace/components/Widgets/data';
import { useAvailableWidgets } from '~/scenes/MyWorkspace/hooks';
import { AppModules, isRoleManager } from '~/services/Permissions';

import {
  WidgetsLayout,
  WidgetsLayoutWidgetProps,
} from './components/WidgetsLayout';
import { useSxStyles } from './useStyles';

export const MobileHome = () => {
  const sxStyles = useSxStyles();

  const loggedInUserRoles = useLoggedInUserRoles();
  const { isModuleEnabled } = useModulesConfig();

  const availableWidgets = useAvailableWidgets();

  const widgets = useMemo(() => {
    const isWorkspaceEnabled = isModuleEnabled(AppModules.WORKSPACE);
    const isManager = isRoleManager(loggedInUserRoles);

    const employeeWidgets: WidgetsLayoutWidgetProps[] = [
      MyWorkspaceWidgetNames.AnnouncementsWidget,
      MyWorkspaceWidgetNames.MyDataWidget,
      MyWorkspaceWidgetNames.MyAbsencesWidget,
      // TODO: Enable later
      // MyWorkspaceWidgetNames.QuickLinksWidget,
    ]
      .map((widgetName) => ({
        widgetName: widgetName,
        role: AdminWorkspaceRoles.EMPLOYEE,
      }))
      .map((widget) => {
        if (MyWorkspaceWidgetNames.MyAbsencesWidget) {
          return {
            ...widget,
            config: {
              disableAbsenceLinks: true,
            },
          };
        }
        return widget;
      });

    const managerWidgets =
      isWorkspaceEnabled && isManager
        ? [
            MyWorkspaceWidgetNames.ApprovalWidget,
            // TODO: Enable later
            // MyWorkspaceWidgetNames.MyTeamWidget,
            // MyWorkspaceWidgetNames.MyTeamAbsencesWidget,
            // MyWorkspaceWidgetNames.TeamAbsencesTodayWidget,
            // MyWorkspaceWidgetNames.TeamAnniversariesWidget,
            // MyWorkspaceWidgetNames.TeamTasksWidget,
            // MyWorkspaceWidgetNames.TeamTimeManagementWidget,
            // MyWorkspaceWidgetNames.TeamCompensationWidget,
            // MyWorkspaceWidgetNames.TeamPerformanceWidget,
            // MyWorkspaceWidgetNames.SolaIntelWidget,
          ].map((widgetName) => ({
            widgetName: widgetName,
            role: AdminWorkspaceRoles.MANAGER,
          }))
        : [];

    return [...employeeWidgets, ...managerWidgets].filter((wp) =>
      availableWidgets.includes(wp.widgetName),
    );
  }, [loggedInUserRoles, availableWidgets, isModuleEnabled]);

  return (
    <Box sx={sxStyles.root}>
      <PortalErrorBoundary>
        <WidgetsLayout widgets={widgets} />
      </PortalErrorBoundary>
    </Box>
  );
};
